module.exports = __webpack_public_path__ + "img/project4_1.cdf9efd8.gif";